import { combineSlices } from "@reduxjs/toolkit";
import { enrollmentStepGs1Slice } from "./enrollmentStepGs1.slice";
import { createAccountGs1Slice } from "./createAccount";

export const gs1Slices = combineSlices(createAccountGs1Slice, enrollmentStepGs1Slice);

